import { compKey } from './key';
export var createFloatingNotificationDriver = function (wrapper) {
    var base = wrapper.$("." + compKey);
    return {
        descriptionText: base.$('.description').text,
        headerText: base.$('.header').text,
        titleText: base.$('.title').text,
        ctaText: base.$('.cta-text').text,
        isIconExists: base.$('.icon-container').exists,
        close: base.$('.cta-close').click,
        click: base.$('.body').click,
        hasAction: base.$('.action-container').exists,
        base: base,
    };
};
//# sourceMappingURL=driver.js.map